// extracted by mini-css-extract-plugin
module.exports = {"badge":"RarityBadge_badge__36baB","medium":"RarityBadge_medium__f5q4z","text":"RarityBadge_text__3wxVZ","small":"RarityBadge_small__1wihO"};